import ParkingAreaMap from "./parkingAreaMap";

export default ParkingAreaMap;